const calendarWritePermissionsTourSteps = (t: any) => {
  return [
    {
      element: '[id^="edit-calendar"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.edit_calendar'
        )}<span class="tour-step-number">(1/4)</span></div>`,
        description: t('tour.calendar.edit_calendar_desc'),
        nextBtnText: t('tour.calendar.next'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.previous'),
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[id^="share-calendar"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.share_calendar'
        )}<span class="tour-step-number">(2/4)</span></div>`,
        description: t('tour.calendar.share_calendar_desc'),
        nextBtnText: t('tour.calendar.next'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.previous'),
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[id^="troubleshoot-calendar"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.troubleshoot_calendar'
        )}<span class="tour-step-number">(3/4)</span></div>`,
        description: t('tour.calendar.troubleshoot_calendar_desc'),
        nextBtnText: t('tour.calendar.next'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.previous'),
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[id^="calendar-actions"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.more_options'
        )}<span class="tour-step-number">(4/4)</span></div>`,
        description: t('tour.calendar.more_options_desc'),
        nextBtnText: t('tour.calendar.all_set'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.start_over'),
        side: 'left',
        align: 'center',
      },
    },
  ]
}

const calendarReadPermissionsTourSteps = (t: any) => {
  return [
    {
      element: '[id^="share-calendar"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.share_calendar'
        )}<span class="tour-step-number">(1/2)</span></div>`,
        description: t(
          'tour.calendar.read_permissions.share_description'
        ),
        nextBtnText: t('tour.calendar.next'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.previous'),
        side: 'left',
        align: 'center',
      },
    },
    {
      element: '[id^="troubleshoot-calendar"]',
      popover: {
        title: ` <div>${t(
          'tour.calendar.troubleshoot_calendar'
        )}<span class="tour-step-number">(2/2)</span></div>`,
        description: t(
          'tour.calendar.read_permissions.troubleshoot_description'
        ),
        nextBtnText: t('tour.calendar.all_set'),
        doneBtnText: t('tour.calendar.end_tour'),
        prevBtnText: t('tour.calendar.start_over'),
        side: 'left',
        align: 'center',
      },
    },
  ]
}

export const getCalendarTourSteps = (hasWritePermissions: boolean, t: any) => {
  return hasWritePermissions
    ? calendarWritePermissionsTourSteps(t)
    : calendarReadPermissionsTourSteps(t)
}
